/**
 * Application Constants
 */
// User Roles
export const UserRole = {
    ADMIN: 'admin',
    MANAGER: 'manager',
    USER: 'user',
};
// Dashboard Types
export const DashboardType = {
    BILLING_FINANCE: 'billing_finance',
    TAX_COMPLIANCE: 'tax_compliance',
    CUSTOMER_OPERATIONS: 'customer_operations',
    HELPDESK_SUPPORT: 'helpdesk_support',
    PROJECT_MANAGEMENT: 'project_management',
    ANALYTICS: 'analytics',
    SYSTEM_ADMIN: 'system_admin',
};
// Account Status
export const AccountStatus = {
    PROSPECT: 'prospect',
    ACTIVE: 'active',
    CHURNED: 'churned',
    INACTIVE: 'inactive',
};
// Deal Stages
export const DealStage = {
    LEAD: 'lead',
    QUALIFIED: 'qualified',
    PROPOSAL: 'proposal',
    NEGOTIATION: 'negotiation',
    CLOSED_WON: 'closed_won',
    CLOSED_LOST: 'closed_lost',
};
// Deal Stage Probabilities (default)
export const DealStageProbability = {
    lead: 10,
    qualified: 25,
    proposal: 50,
    negotiation: 75,
    closed_won: 100,
    closed_lost: 0,
};
// Ticket Status
export const TicketStatus = {
    OPEN: 'open',
    IN_PROGRESS: 'in_progress',
    WAITING_CUSTOMER: 'waiting_customer',
    RESOLVED: 'resolved',
    CLOSED: 'closed',
};
// Priority Levels
export const Priority = {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    URGENT: 'urgent',
};
// API Response Codes
export const HttpStatus = {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    UNPROCESSABLE_ENTITY: 422,
    TOO_MANY_REQUESTS: 429,
    INTERNAL_SERVER_ERROR: 500,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503,
};
// Pagination Defaults
export const Pagination = {
    DEFAULT_PAGE: 1,
    DEFAULT_LIMIT: 20,
    MAX_LIMIT: 100,
};
// Invoice Status
export const InvoiceStatus = {
    DRAFT: 'draft',
    SENT: 'sent',
    PAID: 'paid',
    PARTIAL: 'partial',
    OVERDUE: 'overdue',
    CANCELLED: 'cancelled',
    VOID: 'void',
};
// Invoice Item Type
export const InvoiceItemType = {
    SUBSCRIPTION: 'subscription',
    CONSULTING: 'consulting',
    SERVICE: 'service',
    PRODUCT: 'product',
    OTHER: 'other',
};
// Payment Method
export const PaymentMethod = {
    CHECK: 'check',
    ACH: 'ach',
    WIRE: 'wire',
    CREDIT_CARD: 'credit_card',
    CASH: 'cash',
    ZELLE: 'zelle',
    OTHER: 'other',
};
// Other Income Type
export const OtherIncomeType = {
    FREELANCE: 'freelance',
    CONSULTING: 'consulting',
    INTEREST: 'interest',
    REFUND: 'refund',
    GRANT: 'grant',
    ROYALTY: 'royalty',
    RENTAL: 'rental',
    COMMISSION: 'commission',
    TIP: 'tip',
    REIMBURSEMENT: 'reimbursement',
    OTHER: 'other',
};
// Contract Status
export const ContractStatus = {
    DRAFT: 'draft',
    ACTIVE: 'active',
    EXPIRED: 'expired',
    TERMINATED: 'terminated',
    CANCELLED: 'cancelled',
};
// Billing Frequency
export const BillingFrequency = {
    MONTHLY: 'monthly',
    QUARTERLY: 'quarterly',
    SEMI_ANNUAL: 'semi_annual',
    ANNUAL: 'annual',
};
// Recurring Schedule Status
export const RecurringScheduleStatus = {
    ACTIVE: 'active',
    PAUSED: 'paused',
    CANCELLED: 'cancelled',
    COMPLETED: 'completed',
};
// Billing Alert Type
export const AlertType = {
    OVERDUE_INVOICE: 'overdue_invoice',
    UPCOMING_BILLING: 'upcoming_billing',
    PAYMENT_REMINDER_SENT: 'payment_reminder_sent',
    CONTRACT_EXPIRING: 'contract_expiring',
    PAYMENT_RECEIVED: 'payment_received',
};
// Alert Severity
export const AlertSeverity = {
    INFO: 'info',
    WARNING: 'warning',
    CRITICAL: 'critical',
};
// Email Type
export const EmailType = {
    INVOICE: 'invoice',
    PAYMENT_REMINDER: 'payment_reminder',
    OVERDUE_NOTICE: 'overdue_notice',
};
// Email Status
export const EmailStatus = {
    PENDING: 'pending',
    SENT: 'sent',
    FAILED: 'failed',
};
// Expense Recurrence Frequency
export const ExpenseRecurrence = {
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
    QUARTERLY: 'quarterly',
    ANNUAL: 'annual',
};
// Subscription Billing Cycle
export const SubscriptionBillingCycle = {
    MONTHLY: 'monthly',
    QUARTERLY: 'quarterly',
    SEMI_ANNUAL: 'semi_annual',
    ANNUAL: 'annual',
};
// Subscription Status
export const SubscriptionStatus = {
    ACTIVE: 'active',
    CANCELLED: 'cancelled',
    PAUSED: 'paused',
    TRIAL: 'trial',
    EXPIRING: 'expiring',
};
// Loan Type
export const LoanType = {
    MORTGAGE: 'mortgage',
    AUTO: 'auto',
    EQUIPMENT: 'equipment',
    BUSINESS: 'business',
    PERSONAL: 'personal',
    OTHER: 'other',
};
// Loan Status
export const LoanStatus = {
    ACTIVE: 'active',
    PAID_OFF: 'paid_off',
    DEFERRED: 'deferred',
    DEFAULT: 'default',
};
// Charge Account Type
export const ChargeAccountType = {
    CREDIT_CARD: 'credit_card',
    STORE_CARD: 'store_card',
    BUSINESS_LINE: 'business_line',
};
// Charge Account Status
export const ChargeAccountStatus = {
    ACTIVE: 'active',
    CLOSED: 'closed',
    FROZEN: 'frozen',
};
// Payment Schedule Status
export const PaymentScheduleStatus = {
    PENDING: 'pending',
    PAID: 'paid',
    SKIPPED: 'skipped',
};
// Budget Period Type
export const BudgetPeriodType = {
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
    QUARTERLY: 'quarterly',
    ANNUAL: 'annual',
};
// Help Desk Ticket Source
export const TicketSource = {
    INTERNAL: 'internal',
    WIDGET: 'widget',
    EMAIL: 'email',
    PHONE: 'phone',
};
// Activity Type
export const ActivityType = {
    CALL: 'call',
    EMAIL: 'email',
    MEETING: 'meeting',
    NOTE: 'note',
    FOLLOW_UP: 'follow_up',
    DEMO: 'demo',
    TASK: 'task',
    FILING: 'filing',
    RESEARCH: 'research',
    OTHER: 'other',
};
// Calendar Event Type
export const CalendarEventType = {
    TASK: 'task',
    INVOICE_DUE: 'invoice_due',
    CONTRACT_END: 'contract_end',
    SUBSCRIPTION_RENEWAL: 'subscription_renewal',
    RECURRING_BILLING: 'recurring_billing',
    ACTIVITY: 'activity',
};
// Document Category
export const DocumentCategory = {
    CONTRACT: 'contract',
    INVOICE: 'invoice',
    PROPOSAL: 'proposal',
    REPORT: 'report',
    CORRESPONDENCE: 'correspondence',
    LEGAL: 'legal',
    FINANCIAL: 'financial',
    OTHER: 'other',
};
// Lookup Type (well-known types)
export const LookupType = {
    INDUSTRY: 'industry',
    DEAL_TYPE: 'deal_type',
    TICKET_CATEGORY: 'ticket_category',
    EXPENSE_TAX_CATEGORY: 'expense_tax_category',
    DOCUMENT_CATEGORY: 'document_category',
    ACTIVITY_CATEGORY: 'activity_category',
    MATTER_TYPE: 'matter_type',
    MATTER_SUBTYPE: 'matter_subtype',
    JURISDICTION: 'jurisdiction',
    PRIORITY_LEVEL: 'priority_level',
};
// Approval Status
export const ApprovalStatus = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
    CANCELLED: 'cancelled',
};
// Approval Action
export const ApprovalAction = {
    APPROVED: 'approved',
    REJECTED: 'rejected',
};
// Approval Entity Types
export const ApprovalEntityType = {
    TICKET: 'ticket',
    DOCUMENT: 'document',
    INVOICE: 'invoice',
    CONTRACT: 'contract',
    EXPENSE: 'expense',
};
// Report Data Sources
export const ReportDataSource = {
    INVOICES: 'invoices',
    ACCOUNTS: 'accounts',
    CONTACTS: 'contacts',
    DEALS: 'deals',
    TICKETS: 'tickets',
    EXPENSES: 'expenses',
    ACTIVITIES: 'activities',
    PAYMENTS: 'payments',
    CONTRACTS: 'contracts',
    SUBSCRIPTIONS: 'subscriptions',
};
// Scheduled Report Status
export const ScheduledReportStatus = {
    SUCCESS: 'success',
    FAILED: 'failed',
    SKIPPED: 'skipped',
};
// Previewable MIME types (for in-browser document preview)
export const PreviewableMimeTypes = {
    PDF: 'application/pdf',
    JPEG: 'image/jpeg',
    PNG: 'image/png',
    GIF: 'image/gif',
    WEBP: 'image/webp',
    SVG: 'image/svg+xml',
    TEXT: 'text/plain',
    CSV: 'text/csv',
    MARKDOWN: 'text/markdown',
};
export function isPreviewable(mimeType) {
    return Object.values(PreviewableMimeTypes).includes(mimeType);
}
// OAuth Provider
export const OAuthProvider = {
    MICROSOFT: 'microsoft',
};
// Calendar Sync Direction
export const SyncDirection = {
    TO_OUTLOOK: 'to_outlook',
    FROM_OUTLOOK: 'from_outlook',
    BIDIRECTIONAL: 'bidirectional',
};
// ============================================
// Project Management Constants
// ============================================
// Project Type
export const ProjectType = {
    CONSULTING: 'consulting',
    SOFTWARE_DESIGN: 'software_design',
    SOFTWARE_DEV: 'software_dev',
    STAFF_AUGMENTATION: 'staff_augmentation',
    FIXED_PRICE: 'fixed_price',
    RETAINER: 'retainer',
    INTERNAL: 'internal',
};
// Project Status
export const ProjectStatus = {
    PLANNING: 'planning',
    ACTIVE: 'active',
    ON_HOLD: 'on_hold',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
    ARCHIVED: 'archived',
};
// Project Billing Type
export const ProjectBillingType = {
    TIME_AND_MATERIALS: 'time_and_materials',
    FIXED_PRICE: 'fixed_price',
    RETAINER: 'retainer',
    MILESTONE: 'milestone',
    NOT_BILLABLE: 'not_billable',
};
// Phase Status
export const PhaseStatus = {
    NOT_STARTED: 'not_started',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    SKIPPED: 'skipped',
};
// Project Task Status
export const ProjectTaskStatus = {
    TODO: 'todo',
    IN_PROGRESS: 'in_progress',
    IN_REVIEW: 'in_review',
    BLOCKED: 'blocked',
    DONE: 'done',
    CANCELLED: 'cancelled',
};
// Requirement Category
export const RequirementCategory = {
    FUNCTIONAL: 'functional',
    NON_FUNCTIONAL: 'non_functional',
    BUSINESS: 'business',
    TECHNICAL: 'technical',
    COMPLIANCE: 'compliance',
    SECURITY: 'security',
};
// Requirement Status
export const RequirementStatus = {
    DRAFT: 'draft',
    APPROVED: 'approved',
    IN_PROGRESS: 'in_progress',
    IMPLEMENTED: 'implemented',
    VERIFIED: 'verified',
    DEFERRED: 'deferred',
    REJECTED: 'rejected',
};
// Requirement Link Type
export const RequirementLinkType = {
    IMPLEMENTS: 'implements',
    TESTS: 'tests',
    MITIGATES: 'mitigates',
    VALIDATES: 'validates',
    DEPENDS_ON: 'depends_on',
};
// Risk Category
export const RiskCategory = {
    TECHNICAL: 'technical',
    SCHEDULE: 'schedule',
    BUDGET: 'budget',
    RESOURCE: 'resource',
    SCOPE: 'scope',
    COMPLIANCE: 'compliance',
    EXTERNAL: 'external',
};
// Risk Status
export const RiskStatus = {
    IDENTIFIED: 'identified',
    ANALYZING: 'analyzing',
    MITIGATING: 'mitigating',
    RESOLVED: 'resolved',
    ACCEPTED: 'accepted',
    CLOSED: 'closed',
};
// Risk Likelihood
export const RiskLikelihood = {
    VERY_LOW: 'very_low',
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    VERY_HIGH: 'very_high',
};
// Risk Impact (same scale as likelihood)
export const RiskImpact = RiskLikelihood;
// Risk score mapping (likelihood x impact)
export const RiskScoreMap = {
    very_low: 1,
    low: 2,
    medium: 3,
    high: 4,
    very_high: 5,
};
// Deliverable Status
export const DeliverableStatus = {
    PENDING: 'pending',
    IN_PROGRESS: 'in_progress',
    SUBMITTED: 'submitted',
    APPROVED: 'approved',
    REJECTED: 'rejected',
    REVISION: 'revision',
};
// Project Type Labels (for UI)
export const ProjectTypeLabels = {
    consulting: 'Consulting Engagement',
    software_design: 'Software Design',
    software_dev: 'Software Development',
    staff_augmentation: 'Staff Augmentation',
    fixed_price: 'Fixed-Price Project',
    retainer: 'Retainer',
    internal: 'Internal Project',
};
// ============================================
// Helpdesk Constants
// ============================================
// Ticket Channel (intake source)
export const TicketChannel = {
    PORTAL: 'portal',
    WIDGET: 'widget',
    EMAIL: 'email',
    PHONE: 'phone',
    API: 'api',
};
// Notification Channel
export const NotificationChannel = {
    EMAIL: 'email',
    SMS: 'sms',
    IN_APP: 'in_app',
};
// Notification Type
export const NotificationType = {
    TICKET_CREATED: 'ticket_created',
    TICKET_ASSIGNED: 'ticket_assigned',
    TICKET_REPLY: 'ticket_reply',
    TICKET_RESOLVED: 'ticket_resolved',
    TICKET_STATUS_CHANGE: 'ticket_status_change',
    SLA_WARNING: 'sla_warning',
    SLA_BREACH: 'sla_breach',
    CSAT_SURVEY: 'csat_survey',
    MENTION: 'mention',
    MAINTENANCE: 'maintenance',
    DAILY_DIGEST: 'daily_digest',
};
// Digest Frequency
export const DigestFrequency = {
    REALTIME: 'realtime',
    HOURLY: 'hourly',
    DAILY: 'daily',
};
// Escalation Type
export const EscalationType = {
    RESPONSE_APPROACHING: 'response_approaching',
    RESPONSE_BREACH: 'response_breach',
    RESOLUTION_APPROACHING: 'resolution_approaching',
    RESOLUTION_BREACH: 'resolution_breach',
};
// Escalation Action
export const EscalationAction = {
    NOTIFY: 'notify',
    REASSIGN: 'reassign',
    ESCALATE_PRIORITY: 'escalate_priority',
};
// Knowledge Base Article Status
export const KbArticleStatus = {
    DRAFT: 'draft',
    PUBLISHED: 'published',
    ARCHIVED: 'archived',
};
// Ticket Link Type
export const TicketLinkType = {
    RELATED: 'related',
    DUPLICATE: 'duplicate',
    BLOCKS: 'blocks',
    BLOCKED_BY: 'blocked_by',
    PARENT: 'parent',
    CHILD: 'child',
};
// Application Operational Status (for status widget)
export const AppOperationalStatus = {
    OPERATIONAL: 'operational',
    DEGRADED: 'degraded',
    PARTIAL_OUTAGE: 'partial_outage',
    MAJOR_OUTAGE: 'major_outage',
    MAINTENANCE: 'maintenance',
};
// Incident Severity
export const IncidentSeverity = {
    MINOR: 'minor',
    MAJOR: 'major',
    CRITICAL: 'critical',
};
// Incident Status
export const IncidentStatus = {
    INVESTIGATING: 'investigating',
    IDENTIFIED: 'identified',
    MONITORING: 'monitoring',
    RESOLVED: 'resolved',
};
// Maintenance Window Status
export const MaintenanceStatus = {
    SCHEDULED: 'scheduled',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
};
// Automation Trigger Events
export const AutomationTrigger = {
    TICKET_CREATED: 'ticket_created',
    TICKET_UPDATED: 'ticket_updated',
    TICKET_REPLIED: 'ticket_replied',
    SLA_APPROACHING: 'sla_approaching',
    TICKET_IDLE: 'ticket_idle',
    TICKET_RESOLVED: 'ticket_resolved',
};
// Automation Condition Operators
export const AutomationOperator = {
    EQUALS: 'equals',
    NOT_EQUALS: 'not_equals',
    CONTAINS: 'contains',
    NOT_CONTAINS: 'not_contains',
    IN: 'in',
    NOT_IN: 'not_in',
    GREATER_THAN: 'greater_than',
    LESS_THAN: 'less_than',
};
// Automation Action Types
export const AutomationActionType = {
    SET_PRIORITY: 'set_priority',
    SET_STATUS: 'set_status',
    ASSIGN_TO: 'assign_to',
    ADD_TAG: 'add_tag',
    SEND_NOTIFICATION: 'send_notification',
    ADD_INTERNAL_NOTE: 'add_internal_note',
    SET_CATEGORY: 'set_category',
};
// Dashboard Labels (for UI)
export const DashboardLabels = {
    billing_finance: 'Finance',
    tax_compliance: 'Tax & Compliance',
    customer_operations: 'Customer Operations',
    helpdesk_support: 'Helpdesk & Support',
    project_management: 'Project Management',
    analytics: 'Analytics & Reports',
    system_admin: 'System Admin',
};
// Dashboard Descriptions (for UI)
export const DashboardDescriptions = {
    billing_finance: 'Manage subscriptions, invoicing, payments, and accounting',
    tax_compliance: 'Tax reporting, audit logs, and compliance tracking',
    customer_operations: 'CRM, accounts, contacts, deals, and customer success',
    helpdesk_support: 'Support tickets, knowledge base, SLA policies, and IT operations',
    project_management: 'Product development, consulting delivery, and time tracking',
    analytics: 'Business intelligence, report builder, and scheduled reports',
    system_admin: 'Platform configuration, system status, and administration',
};
//# sourceMappingURL=index.js.map